import $ from 'jquery'
import gsap from 'gsap'

const SCROLLED_CLASS = 'main-nav--scrolled'
const TRESHOLD = 20

class HeaderScroll {
  constructor(selector = '.main-nav') {
    this.header = $(selector)

    this.background = $('.main-nav-desktop__submenu__background')
    this.isScrolled = false

    this.listen()
  }

  listen() {
    $(window).on('scroll', () => {
      const scrolled = window.scrollY || window.pageYOffset
      if (scrolled <= TRESHOLD && this.isScrolled) {
        this.isScrolled = false
        this.removeHeaderScrolledState()
        this.updateSubmenuBackground()
      } else if (scrolled > TRESHOLD && !this.isScrolled) {
        this.isScrolled = true
        this.addHeaderScrolledState()
        this.updateSubmenuBackground()
      }
    })
  }

  removeHeaderScrolledState() {
    this.header.removeClass(SCROLLED_CLASS)
  }

  addHeaderScrolledState() {
    this.header.addClass(SCROLLED_CLASS)
  }

  updateSubmenuBackground() {
    const activeMenu = $('.main-nav-desktop__nav-mainlinks__item.active')
    const submenu = $('.main-nav-desktop__submenu', activeMenu)

    const currentHeight = this.background.height()
    const targetHeight = submenu.height()

    gsap.fromTo(
      this.background,
      {
        height: currentHeight,
      },
      {
        height: targetHeight,
        duration: 0.175,
        ease: 'sine.inOut',
      }
    )
  }
}

export default HeaderScroll
